import { CaseReducer, createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RecaptchaContext } from "../globalContext/recaptcha.interface";
import { RootState } from "../store";

type RecaptchaState = RecaptchaContext;

export const initialState: RecaptchaState = {
	token: '',
}

const setTokenReducer: CaseReducer<RecaptchaState, PayloadAction<{ token: string }>> = (state, action) => {
	state.token = action.payload.token;
}

const setResetTokenReducer: CaseReducer<RecaptchaState> = (state) => {
	state.token = '';
}

export const RecaptchaSlice = createSlice({
	name: 'recaptcha',
	initialState,
	reducers: {
		setToken: setTokenReducer,
		setResetToken: setResetTokenReducer,
	},
})

export const selectToken = (state: RootState) => state.RecaptchaState.token;
export const { setToken, setResetToken } = RecaptchaSlice.actions;